// @ts-nocheck
import React from "react";
import { ct } from "../../constant-Utils";
import { copyText } from "../../../base/util/copyText.web";
import ConfirmationAlert from "../../welcome-dashboard/components/payment/ConfirmationAlert";
import toast from "react-simple-toasts";
const CopyLinkPop = ({ link, copyUrl, isCopied, handleConfirmAction }) => {
    const handleLargeLink = (link) => {
        if (link.length > 30) {
            return link.slice(0, 30) + "...";
        }
        return link;
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(ConfirmationAlert, { handleConfirmAction: handleConfirmAction, title: React.createElement(React.Fragment, null,
                React.createElement("span", null, ct("rta-trmc.chat.copyLink")),
                React.createElement("div", { className: "d-flex align-items-center" },
                    React.createElement("span", { className: "mr-4" }, link ? handleLargeLink(link.toLowerCase()) : ""),
                    isCopied ? (React.createElement("i", { className: "fa fa-check theme-font-color", "aria-hidden": "true" })) : (React.createElement("i", { className: "fa fa-clone my-recordings-icons theme-font-color", onClick: async (e) => {
                            e.preventDefault();
                            const res = await copyText(link.toLowerCase());
                            if (res) {
                                toast(ct("rta-trmc.chat.copiedLink"));
                                copyUrl();
                            }
                        }, id: `copy-chat-link` })))), showCloseIcon: true, showFooter: false })));
};
export default CopyLinkPop;
